import { getUser } from "./getUser";
import { WEBVIEW_PATHS } from "./webviews";

export async function buildWebviewPath(
  origin: string,
  userId: string | undefined,
  webviewPath: string,
  leaseId: string,
  accessToken: string,
  propertyId?: string
): Promise<string> {
  if (!userId || !propertyId) {
    const user = await getUser(leaseId, accessToken);
    userId = user.userId.toString();
    propertyId = user.propertyId.toString();
  }

  const baseLeasePath = `lease/:leaseId`;
  let path = "";

  // this is to account for info desk, its an antipattern but nothing to do about it at this point
  // /$buildingId/page/$pageId
  if (webviewPath.includes("/page/")) {
    path = webviewPath.replace(":leaseId", leaseId);
  }

  if (webviewPath.includes(WEBVIEW_PATHS.INSURANCE_MARKETPLACE)) {
    path = `checklist/:userId/insurance-marketplace`;
  }

  switch (webviewPath) {
    case WEBVIEW_PATHS.CHECKLIST:
      path = `checklist/:userId`;
      break;
    case WEBVIEW_PATHS.PROFILE:
      path = `checklist/:userId/profile`;
      break;
    case WEBVIEW_PATHS.INSURANCE_QUOTE:
      path = `checklist/:userId/insurance`;
      break;
    case WEBVIEW_PATHS.UTILITIES:
      path = `checklist/:userId/utilities/:userId`;
      break;
    case WEBVIEW_PATHS.SCHEDULE_MOVE_IN:
      path = `checklist/:userId/schedule-move-in`;
      break;
    case WEBVIEW_PATHS.COMMUNITY_SURVEY:
      path = `checklist/:userId/community-survey`;
      break;
    case WEBVIEW_PATHS.CHECKOUT:
      path = `checklist/:userId/cart`;
      break;
    case WEBVIEW_PATHS.RENT:
      path = `rent/:userId`;
      break;
    case WEBVIEW_PATHS.FITNESS_PAYMENTS:
      path = `fitness/payment-methods`;
      break;
    case WEBVIEW_PATHS.INSPECTION_CHECKLIST:
      path = `inspection-checklist`;
      break;
    case WEBVIEW_PATHS.INSURANCE_PROOF_CURRENT:
      path = `insurance/upload-proof`;
      break;
    case WEBVIEW_PATHS.INSURANCE_QUOTE_CURRENT:
      path = `insurance-quote`;
      break;
    case WEBVIEW_PATHS.AMENIFY:
      path = `amenify`;
      break;
    case WEBVIEW_PATHS.BILT:
      window.location.href = import.meta.env.VITE_BILT_URL;
      break;
    case WEBVIEW_PATHS.BILT_REWARDS:
      path = "bilt-rewards";
      break;
    case WEBVIEW_PATHS.MAINTENANCE:
      path = `maintenance/:propertyId`;
      break;
    case WEBVIEW_PATHS.EVENTS:
      path = `events/property/:propertyId`;
      break;
    case WEBVIEW_PATHS.COMMUNITY_FEED:
      path = `community-feed`;
      break;
    case WEBVIEW_PATHS.AMENITIES:
      path = `amenities/:propertyId`;
      break;
    case WEBVIEW_PATHS.FITNESS:
      path = `fitness/:propertyId`;
      break;
    case WEBVIEW_PATHS.BOOKINGS:
      path = `bookings`;
      break;
    case WEBVIEW_PATHS.MARKETPLACE:
      path = `marketplace`;
      break;
    case WEBVIEW_PATHS.GUESTS:
      path = `guests`;
      break;
    case WEBVIEW_PATHS.FEEDBACK:
      path = `my-feedback/reviews`;
      break;
  }

  const pathWithParams = `${baseLeasePath}/${path}`
    .replace(":leaseId", leaseId)
    .replace(":userId", userId)
    .replace(":propertyId", propertyId ?? "")
    .replace(/\/+/g, "/");

  if (origin) {
    return `${origin}/${pathWithParams}`;
  }

  return `/${pathWithParams}`;
}
